import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const CustomerFilterResultServiceConfig = {
  name: "CustomerFilterResult",
  annotations: []
} as ServiceConfig;